import React, {useEffect, useState} from 'react';
import './App.css';
import NetworkGraph from "./NetworkGraph";
import Test from "./Test";
import {createTheme} from '@mui/material/styles';
import {primary, secondary} from "./Globals";

function App() {
    const [primaryColor, setPrimaryColor] = useState(primary);
    const [secondaryColor, setSecondaryColor] = useState(secondary);
    const [darkMode, setDarkMode] = useState(true);
    useEffect(() => {
        document.documentElement.style.setProperty('--dropdown-arrow-color', darkMode ? '#171717' : '#000000')
    }, [darkMode]);
    let theme = createTheme({
        components: {
            MuiTooltip: {
                styleOverrides: {
                    tooltip: {
                        backgroundColor: '#FFFFFF', // Set the background color
                        color: 'rgba(0, 0, 0, 0.87)', // Set the text color
                        fontSize: 14,
                        boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.75)',
                    },
                    arrow: {
                        color: '#FFFFFF', // Set the arrow color (replace with your desired color)
                    },
                },

            },

        },
        palette: {
            mode: darkMode ? 'dark' : 'light',
            primary: {
                main: primaryColor,
            },
            secondary: {
                main: secondaryColor,
            },

            text: {
                primary: darkMode ? "#FFFFFF" : "#000000", // primary text color
                secondary: darkMode ? "#FFFFFF" : "#000000", // secondary text color
            },
            textColor: {
                main: darkMode ? "#FFFFFF" : "#000000",
            },
            textDark: {
                main: "#000000",
            },
            bglight: {
                main: "#FFFFFF",
            },
            bgdark: {
                main: "#000000",
            }
        },
        typography: {
            fontFamily: 'Arial, sans-serif', // Customize your font here
            settingsText: {
                fontSize: 14,
                fontFamily: "Century Gothic, monospace",
            }
        },

    });

    return (
        <div className={darkMode ? "dark" : ""}>
            <NetworkGraph theme={theme} primaryColor={primaryColor} secondaryColor={secondaryColor}
                          setPrimaryColor={setPrimaryColor} setSecondaryColor={setSecondaryColor}
                            darkMode={darkMode} setDarkMode={setDarkMode}/>
        </div>
    );
}

export default App;
